exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.item-icon[data-v-187342d6] {\n  display: flex;\n  align-self: center;\n  position: relative;\n  margin: 0;\n  color: #C59D5F;\n  font-weight: bold;\n}\n", "", {"version":3,"sources":["/home/runner/work/online-store/online-store/src/components/header/NavigationItems/CloseButton.vue"],"names":[],"mappings":";AAAA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,kBAAkB;CAAE","file":"CloseButton.vue","sourcesContent":[".item-icon {\n  display: flex;\n  align-self: center;\n  position: relative;\n  margin: 0;\n  color: #C59D5F;\n  font-weight: bold; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-187342d6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/header/NavigationItems/CloseButton.vue
// module id = SO6l
// module chunks = 18